module.exports = __webpack_public_path__ + "static/media/S.db249c16.jpg";